export const labels_en = {
  applicationNameLong: "SelfCare",
  applicationNameShort: "SC",
  username: "Username",
  usernamePlaceholder: "Enter username",
  password: "Password",
  passwordPlaceholder: "Enter password",
  confirmPassword: "Confirm password",
  login: "Login",
  needAccount: "Need an account?",
  register: "Register",
  registration: "Registration",
  logout: "Logout",
  home: "Home",
  all: "All",
  search: "Search",
  name: "Name",
  namePlaceholder: "Enter name",
  uriPlaceholder: "Enter URI",
  institutionPlaceholder: "Enter institution",
  id: "ID",
  description: "Description",
  descriptionPlaceholder: "Enter description",
  closeButton: "Close",
  saveButton: "Save",
  comments: "Comments",
  commentBox: "Write a message...",
  comment: "Comment",
  fullName: "Name and Surname",
  previous: "Previous",
  next: "Next",
  submit: "Submit",
  cancel: "Cancel",
  pageNotFound: "Page not found",
  welcome: "DEP - SelfCare - Welcome",
  administration: "Administration",
  knowledgeManagement: "Knowledge management",
  classification: "Classification",
  adminClassification: "Classification administration",
  classificationType: "Classification type",
  classificationStatus: "Classification status",
  addButton: " Add",
  deleteButton: " Delete",
  deleteButtonDescription: "Delete checked rows",
  code: "Code",
  codePlaceholder: "Entry code",
  dateFrom: "Date from",
  dateFromPlaceholder: "Entry date from",
  dateTo: "Date to",
  dateFromTo: "Date (from-to)",
  dateToPlaceholder: "Entry date to",
  statusPlaceholder: "Choose status",
  typePlaceholder: "Choose type",
  generalData: "General data",
  classificationModel: "Classification's model",
  chooseModel: "Choose model",
  selectedModels: "Selected models",
  noData: "No data",
  descriptionUsage: "Description usage",
  saved: "Saved",
  deleted: "Deleted",
  knowledgeType: "Knowledge type",
  knowledgeCopyright: "Copyright",
  knowledgeItem: "Knowledge item",
  knowledgeSource: "Knowledge source",
  lifeCycle: "Life cycle",
  lifeCycles: "Life cycles",
  lifeCycleStateType: "Life cycle state type",
  lifeCycleChangedBy: "Life cycle set by",
  changedBy: "Set by",
  recordedBy: "Recorded by",
  modifiedBy: "Last updated by",
  userInformation: "User information",
  note: "Note",
  uri: "URI",
  expand: "Expand",
  selectedClassifications: "Selected classifications",
  chooseClassification: "Choose classification",
  additionalData: "Additional data",
  documents: "Documents",
  documentsUpdate: "Document info update",
  contentType: "Content type",
  dateCreated: "Creation date",
  areYouSureDelete: "Are you sure you want to delete this document?",
  no: "No",
  yes: "Yes",
  actions: "Actions",
  upload: "Upload",
  selectFiles: "Select files",
  selectedFilesNum: "file(s)",
  knowledge: "Knowledge",
  previousLifeCycle: "Previous life cycle",
  currentLifeCycle: "Current life cycle",
  date: "Date",
  ratings: "ratings",
  rateNow: "Rate now",
  myRating: "My rating",
  institution: "Institution",
  messageLog: "Messages",
  message: "Message",
  details: "Details",
  selectedKnowledgeSource: "Selected knowledge source",
  lifeCycleClassDefinitions: "Life cycle class definitions",
  lifeCycleClassDefinition: "Life cycle class definition",
  possibleNextStates: "Possible next states",
  selectedNextStates: "Selected next states",
  lifeCycleTransitions: "Life cycle Transitions",
  messageLogType: "Message type",
  userRoles: "User roles",
  roleTypes: "Role types",
  partyRoleTypeDiscriminatorPlaceholder: "Choose discriminator",
  roleType: "Role type",
  involvementRoleTypePlaceholder: "Select involvement role type",
  extensions: "Extensions",
  users: "Users",
  applicationUsers: "Application users",
  externalUsers: "External users",
  firstName: "First name",
  lastName: "Family name",
  email: "E-mail",
  user: "User",
  roleTypeName: "Role type name",
  userRole: "User role",
  roleTypePlaceholder: "Choose role type",
  involvementRole: "Additional Involvement Role Types",
  involvementRoleTypes: "Involvement Role Types",
  involvementRoleType: "Involvement Role Type",
  partyRoleTypeDiscriminator: "Discriminator",
  sendMessage: "Send",
  advancedSearchPlaceholder: "Enter words",
  advancedSearch: " Advanced search",
  correctWords: "Correct words",
  anyWords: "Any of those words",
  nonWords: "Non of those words",
  phrases: "Phrases",
  resetAdvancedSearchParams: "Reset",
  advancedSearchDescription: "Separate words with a comma",
  isAlreadySelected: "is already selected",
  isAdded: "is added",
  isRemoved: "is removed",
  status: "Status",
  type: "Type",
  parent: "Parent",
  parentPlaceholder: "Choose parent",
  active: "Active",
  inactive: "Inactive",
  advancedSearchParamsDelete: "Delete advanced search parameteres",
  classificationDetail: "Classification details",
  childInvolvementRoleTypes: "Inherited Involvement Role Types",
  atTime: ", at time: ",
  rating: "Rating",
  backButton: "Back",
  newTab: "Open in new tab",
  reactivateItem: "Reactivate item",
  operations: "Operations",
  involvementRoles: "Involvement Roles",
  usersAndSecurity: "Users and Security",
  entities: "Entities",
  deleteItem: "Delete item",
  settings: "Settings",
  language: "Language"
};
